import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class AppService {

  private isSpinner = signal(false);

  constructor() { }

  get spinnerData() {
    const vm = this;
    return vm.isSpinner();
  }

  set spinnerData(value) {
    const vm = this;
    vm.isSpinner.set(value);
  }

}
